import { useQuery } from "@tanstack/react-query";
import { Constants } from "../../../assets/utils/lib/constants";
import { QuestionnaireResponseClient } from "../../../services/proxies/questionnaire/questionnaireResponseClient";

export namespace QuestionnaireResponseService {
  const questionnaireResponseClient = new QuestionnaireResponseClient();

  export const getQuestionnaireResponseQuery = (questionnaireId: string | undefined) =>
    useQuery({
      queryKey: ["questionnaireResponseQuery", questionnaireId],
      queryFn: async () =>
            await questionnaireResponseClient.getQuestionnaireResponseAsync(questionnaireId),
        enabled: Boolean(questionnaireId) && questionnaireId !== Constants.emptyGuid,
    });

  export const gridQuery = (questionnaireId: string | undefined) =>
    useQuery({
      queryKey: ["SearchDeviceQuestionnaires", questionnaireId],
      queryFn: async () =>
          await questionnaireResponseClient.searchQuestionnaireResponsesAsync(questionnaireId),
    });
}
